import { GridColumnSortDocuments } from 'src/components/Reusable/Grid/GridColumnSort/GridColumnSort.constants'

export enum CompanyLinkTypes {
  GENERAL_INQUIRY_EMAIL = 'generalInquiryEmail',
  PRIVACY_POLICY = 'privacyPolicy',
  COMPANY_URL = 'companyUrl',
}

export enum ResourcePreviewTabs {
  PUBLIC = 'Public',
  SEMI_PUBLIC = 'Confidential',
  PRIVATE = 'Restricted',
}

export const CompanyLinkPlaceholders: Record<CompanyLinkTypes, string> = {
  [CompanyLinkTypes.GENERAL_INQUIRY_EMAIL]: 'General Inquiry Email',
  [CompanyLinkTypes.PRIVACY_POLICY]: 'Privacy Policy',
  [CompanyLinkTypes.COMPANY_URL]: 'Company URL',
}

export const RESOURCES_GRID_HEADER_COLUMNS: {
  name: string
  value: (typeof GridColumnSortDocuments)[keyof typeof GridColumnSortDocuments]
}[] = [
  {
    name: '',
    value: GridColumnSortDocuments.MIMETYPE,
  },
  {
    name: 'Name',
    value: GridColumnSortDocuments.NAME,
  },
  {
    name: 'Date Added',
    value: GridColumnSortDocuments.CREATED_AT,
  },
  {
    name: '',
    value: GridColumnSortDocuments.ACTION,
  },
]
